import { withTranslation } from '../Translator';
import AsControl from '../AsControl';
import bindControlToForm from '../../utils/hoc/formHelpers/bindControlToForm';
import autoSaved from '../../utils/hoc/formHelpers/autoSaved';
import PureTagsInput from './TagsInput';
import WithAutoComplete from './hoc/WithAutoComplete';

export const PureTagsInputWithAutoSuggest = withTranslation('components')(WithAutoComplete()(PureTagsInput));

export const TagsInput = AsControl()(PureTagsInput);
export const TagsInputControl = bindControlToForm()(TagsInput);
export const AutoSavedTagsInputControl = autoSaved({ saveOnBlur: true })(TagsInputControl);

export const TagsInputWithAutoSuggest = AsControl()(PureTagsInputWithAutoSuggest);
export const TagsInputWithAutoSuggestControl = bindControlToForm()(TagsInputWithAutoSuggest);
export const AutoSavedTagsInputWithAutoSuggestControl = autoSaved({ saveOnBlur: true })(TagsInputWithAutoSuggestControl);
